import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    Button,
    Typography,
    message,
    Spin,
    Divider,
    Row,
    Col
} from "antd";
import {
    COMMON_ERROR_MSG,
    SESSION_TOKEN
} from "../../../constants/constants";
import LeftLayout from "../../pageHeader/LeftLayout";
import _consumerService from "../../../modules/consumerService";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";
import { RightOutlined } from "@ant-design/icons";
import "../../../assets/dist/ConsumerProject/Common.css";
import _AdministratorService from "../../../modules/AdministratorService";
import Login from "../../../components/Login/Login";

const { Title, Link } = Typography;

const AdministratorLogin = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [isNewAccountCreateFlag, setIsNewAccountCreateFlag] = useState(false);

    useEffect(() => {
        getAdministratorCount();
    }, []);

    const createNewAccount = () => {
        history.push(routes.createAdministratorAccount.path);
    };

    const consumerLogin = () => {
        history.push(routes.registeredEmail.path);
    };

    const capitalProviderLogin = () => {
        history.push(routes.capitalProviderLogin.path);
    };

    const forgotPassword = () => {
        history.push(routes.forgotAdministratorLoginPasswordSendOTP.path);
    };

    const handleConfirmSendOTP = async (values) => {
        let reqObj = {
            Email: values.email,
            Password: values.password,
        }
        setLoading(true);
        try {
            const res = await _AdministratorService.bankerLogin(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("administratorUserId", res?.data?.Obj?.Id);
                localStorage.setItem("administratorLoginEmail", reqObj.Email);
                localStorage.setItem("administratorFirstName", res?.data?.Obj?.FirstName);
                localStorage.setItem("IsConsumerFlag", JSON.stringify(false));
                localStorage.setItem("IsAdministratorFlag", JSON.stringify(true));
                localStorage.setItem("IsCapitalProviderFlag", JSON.stringify(false));
                history.push({
                    pathname: routes.administratorDashboard.path,
                    state: { "email": values.email }
                });
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const getAdministratorCount = async () => {
        setLoading(true);
        try {
            const res = await _AdministratorService.getAdministratorCount();

            if (res?.data?.IsSuccess) {

                if (res.data.Obj?.Count === 0) {
                    setIsNewAccountCreateFlag(true);
                } else {
                    setIsNewAccountCreateFlag(false);
                }

            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.error(err);
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };


    const onFinish = (values) => {
        handleConfirmSendOTP(values);
    };

    return (
        <Spin spinning={loading}>
            <Login
                role="administrator"
                title="Administrator Portal"
                onFinishHandle={onFinish}
                createNewAccount={createNewAccount}
                forgotPassword={forgotPassword}
                capitalProviderLogin={capitalProviderLogin}
                consumerLogin={consumerLogin}
                // isNewAccountCreateFlag={true}
                isNewAccountCreateFlag={isNewAccountCreateFlag}

            />

            {/* <LeftLayout>
                <div className="w450 login-page">
                    <Title className="pageTitle" level={3}>
                        Administrator Portal
                    </Title>

                    <Form
                        name="verify-email"
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Email is required",
                                },
                                { type: 'email', message: 'Enter a valid Email' }
                            ]}
                        >
                            <Input
                                placeholder="Enter Email"
                                autoComplete="email"
                                maxLength={50}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Password is required" }]}
                        >
                            <Input.Password
                                autoComplete="current-password"
                                placeholder="Enter Password"
                                maxLength={30}
                            />
                        </Form.Item>
                        <div className="forgot-text forgTxt">
                            <Link
                                onClick={forgotPassword}
                                className="fbold"
                            >
                                Forgot Password? <RightOutlined />
                            </Link>
                        </div>
                        <Row justify="space-between" align="middle" className="mt8">
                            <Col>
                                <Form.Item className="mb0">
                                    <Button
                                        htmlType="submit"
                                        className="login-btn loginBtn"
                                        shape="round"
                                    >
                                        Login <RightOutlined />
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Link
                                    onClick={createNewAccount}
                                    className="fbold"
                                >
                                    Create A New Account <RightOutlined />
                                </Link>
                            </Col>
                        </Row>
                        <Divider plain orientation="center">
                            OR
                        </Divider>

                        <Form.Item className="mt20 mb10">
                            <Link onClick={consumerLogin}>
                                Investor Login <RightOutlined />
                            </Link>
                        </Form.Item>
                        <Form.Item>
                            <Link onClick={capitalProviderLogin}>
                                Capital Provider Login <RightOutlined />
                            </Link>
                        </Form.Item>
                    </Form>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default AdministratorLogin;